import { BaseService } from "./BaseService";

export class FaqsService extends BaseService {
  getFaqsChapters() {
    return this.request("api/Faqs/GetFaqsChapters/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getAttachment(idFaq) {
    return this.request(`api/Faqs/GetAttachment/${idFaq}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }
}

const faqsService = new FaqsService();

export default faqsService;
